<li class="dropitem dropdown-item dropdown dropright" [ngClass]="bg" (mouseenter)="cancelarEsconder()" (mouseleave)="agendarEsconder()">
  <a class="nav-link dropdown-toggle" (mouseover)="mostrar()" [class.show]="show" href="#"
    id="navbarDropdown{{menu.nome | lowercase}}" role="button" data-toggle="dropdown" aria-haspopup="true"
    aria-expanded="false">
    <i *ngIf="menu.icon" [class]="menu.icon"></i> {{ menu.nome }}
  </a>
  <div class="dropdown-menu" [ngClass]="bg" (mouseenter)="cancelarEsconder()" (mouseleave)="agendarEsconder()" [class.show]="show"
    attr.aria-labelledby="navbarDropdown{{menu.nome | lowercase}}">
    <ng-container *ngFor="let m of menu.menuItens">
      <div *ngIf="m.divider; else noDivider" class="dropdown-divider"></div>
      <ng-template #noDivider>
        <a *ngIf="!m.menuItens" class="dropdown-item" [routerLink]="m.link"> <i *ngIf="m.icon" [class]="m.icon"></i>
          {{ m.nome }}</a>
        <app-menu-modulo-subitem2 [bg]="bg" *ngIf="m.menuItens" [menu]="m"></app-menu-modulo-subitem2>
      </ng-template>
    </ng-container>
  </div>
</li>